import { render, staticRenderFns } from "./salesPromotion.vue?vue&type=template&id=c6303cf8&"
import script from "./salesPromotion.vue?vue&type=script&lang=js&"
export * from "./salesPromotion.vue?vue&type=script&lang=js&"
import style0 from "./salesPromotion.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports